import { render, staticRenderFns } from "./solvePlanInfo.vue?vue&type=template&id=315c298d&scoped=true&"
import script from "./solvePlanInfo.vue?vue&type=script&lang=js&"
export * from "./solvePlanInfo.vue?vue&type=script&lang=js&"
import style0 from "./solvePlanInfo.vue?vue&type=style&index=0&id=315c298d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c298d",
  null
  
)

export default component.exports